import type { InjectionKey } from 'vue';
import type { InjectionValue } from '@tools/types';
import { type CrmDomainDomainUbosUboContext } from '@services/crm-public/orval-api/model/crmDomainDomainUbosUboContext';

export const toonUboCheckResultatenInjectionKey = Symbol('toonUboCheckResultaten') as InjectionKey<
  InjectionValue<boolean>
>;

export const uboContextInjectionKey = Symbol('uboContext') as InjectionKey<
  InjectionValue<CrmDomainDomainUbosUboContext>
>;
